import { render, staticRenderFns } from "./borrowJkPage.vue?vue&type=template&id=4cbb2932&"
import script from "./borrowJkPage.vue?vue&type=script&lang=js&"
export * from "./borrowJkPage.vue?vue&type=script&lang=js&"
import style0 from "./borrowJkPage.vue?vue&type=style&index=0&id=4cbb2932&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports